
let keys="Uhlhnk45145ooumm"
let ivs="2022012256256456"

const CryptoJS = require('crypto-js');  //引用AES源码js


const key = CryptoJS.enc.Utf8.parse(keys);  //十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse(ivs);   //十六位十六进制数作为密钥偏移量

//加密方法
export const aesEncrypt = (data) => {
    let encrypted = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding,
    })
    // 转换为字符串
    return encrypted.toString()
}

//解密方法
export const aesDecrypt = (data) => {
    let decrypted = CryptoJS.AES.decrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding,
    })
    // 转换为 utf8 字符串
    let decryptedStr = decrypted.toString(CryptoJS.enc.Utf8)
    return decryptedStr
}